// imports react
import React from "react";

//imports libraries
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

//imports components
import styles from "../styles/evokchat.module.css";
import { ProfileRadarChart } from "./ProfileRadarChart";

export function UserSkillsProfile({ userData, darkMode }) {
  return (
    <div className="card mb-5 mb-xl-10"  data-bs-theme={darkMode ? ('dark') : ('light')}>
      <div className="card-header">
        <div className="card-title">
          <h3>Suas Habilidades</h3>
        </div>
      </div>

      <div className="card-body p-0">
        {userData.relatorioEnviado ? (
          <ProfileRadarChart needShowPontuation={true}/>
        ) : (
          <p className="p-8">Você precisa responder o <strong>questionário</strong> primeiro!</p>
        )}
      </div>
    </div>
  );
}
